import './AdSectionSkeleton.scss';

const DigitalSkeleton = () => {

  return (
    <div className="home__ad__section__skeleton">
      <div className="left__side__ad__section__skeleton">
        <div className="ad__content__skeleton">
          <div className="ad__accent__skeleton"></div>
          <div className="ad__title__skeleton"></div>
          <div className="ad__title__skeleton--primary"></div>
          <div className='ad__subtitle__wrapper__skeleton'>
            {[...Array(4)].map((_, index) => (
              <div key={index} className="ad__subtitle__skeleton" />
            ))}
            <div className="ad__subtitle__skeleton--primary"></div>
          </div>
        </div>
      </div>
      <div className="right__side__ad__section__skeleton">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="ad__services__links__item__skeleton">
            <div className="ad__links__item__skeleton"></div>
            <div className="ad__links__item__skeleton--primary"></div>
            <div className='ad__text__item__wrapper__skeleton'>
              {[...Array(4)].map((_, i) => (
                <div key={i} className="ad__text__item__skeleton"></div>
              ))}
              <div className="ad__text__item__skeleton--primary"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DigitalSkeleton;